import styled from "styled-components";

const BaseButton = styled.button`
  border-radius: ${(props) => props.theme.border.radius};
  height: 36px;
  padding: 0 1rem;
  font-family: ${(props) => props.theme.typography.fontFamily.main};
  font-weight: normal;
  font-size: 1rem;
  line-height: 1.375rem;
  color: ${(props) => props.theme.colors.primary.light};
  text-align: center;
  cursor: pointer;
  background-color: white;
  border: 2px solid ${(props) => props.theme.colors.primary.light};
  outline: none;
`;

export const SolutionTitleWrapper = styled.div`
  background: #fff;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const SolutionTitle = styled.p`
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  color: #ff5203;
  margin: 0;
  text-transform: initial;
`;

export const AllocationSubTitle = styled.p`
  font-family: "Lato";
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  color: #767676;
  margin: 0;
  padding: 0 16px;
`;

export const CloseButton = styled(BaseButton)`
  background-color: transparent;
  border: none;
`;

export const SolutionButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const AllocationFooter = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  padding: 16px 12px;
`;

export const CancelButton = styled(BaseButton)`
  border: 2px solid #767676;
  box-sizing: border-box;
  border-radius: 4px;
  color: #767676;
  margin-right: 0;
  min-width: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ConfirmButton = styled(BaseButton)`
  margin-right: 12px;
  background: ${(props) => props.theme.colors.primary.light};
  border-radius: 4px;
  border: 1px solid ${(props) => props.theme.colors.primary.light};
  color: white;
  min-width: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:disabled {
    background-color: #ccc;
    border-color: #ccc;
    cursor: not-allowed;
  }
`;

export const AllocationLoader = styled.div`
  padding: 16px;
  text-align: center;
`;

export const AllocationTableContainer = styled.div`
  padding: 16px;
  max-height: 400px;
  overflow-y: scroll;
`;

export const AllocationTable = styled.table`
  margin: 12px 0;
  width: 100%;
  border-bottom: 1px solid #f6f6f6;
`;

export const AllocationTableData = styled.td`
  padding: 16px 6px !important;
  font-size: 16px;
  font-family: Lato;
`;

export const AllocationTableHeaderRow = styled.tr`
  background-color: #f6f6f6;
`;

export const AllocationTableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f6f6f6;
  }
`;

export const EmptySolutionsMessage = styled.p`
  font-family: "Lato";
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  margin: 0;
  padding: 16px;
  color: red;
`;

export const AllocationErrorMessage = styled.div`
  color: red;
  font-size: 16px;
  font-family: Lato;
  line-height: 22px;
  display: flex;
  align-items: center;
`;
